var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4375 14.5256C43.9447 13.9673 43.3387 13.5203 42.6598 13.2141C41.9809 12.908 41.2447 12.7498 40.5 12.75H30.75V10.5C30.7475 8.31273 29.8775 6.21575 28.3309 4.66911C26.7843 3.12247 24.6873 2.25248 22.5 2.25C22.0823 2.25005 21.6729 2.36636 21.3176 2.58592C20.9622 2.80547 20.675 3.1196 20.4881 3.49312L13.6088 17.25H6C5.00544 17.25 4.05161 17.6451 3.34835 18.3484C2.64509 19.0516 2.25 20.0054 2.25 21V37.5C2.25 38.4946 2.64509 39.4484 3.34835 40.1516C4.05161 40.8549 5.00544 41.25 6 41.25H38.25C39.5296 41.2498 40.765 40.7823 41.7242 39.9354C42.6833 39.0884 43.3002 37.9203 43.4587 36.6506L45.7087 18.6506C45.8013 17.9122 45.7358 17.1626 45.5167 16.4514C45.2975 15.7403 44.9296 15.0838 44.4375 14.5256ZM6.75 21.75H12.75V36.75H6.75V21.75ZM41.25 18.0938L39 36.0938C38.977 36.276 38.888 36.4435 38.7498 36.5645C38.6115 36.6854 38.4337 36.7514 38.25 36.75H17.25V20.0306L23.7787 6.975C24.5028 7.23765 25.1284 7.71688 25.5706 8.34756C26.0127 8.97824 26.25 9.72977 26.25 10.5V15C26.25 15.5967 26.4871 16.169 26.909 16.591C27.331 17.0129 27.9033 17.25 28.5 17.25H40.5C40.6069 17.2492 40.7127 17.2712 40.8104 17.3146C40.9081 17.358 40.9954 17.4218 41.0664 17.5017C41.1375 17.5816 41.1906 17.6758 41.2222 17.7779C41.2539 17.88 41.2634 17.9877 41.25 18.0938Z",
    fill: "url(#paint0_linear_1559_11615)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1559_11615",
    x1: 23.9998,
    y1: 2.25,
    x2: 23.9998,
    y2: 41.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/ThumbsUp.db6434b0564ec80398b027089209e7bb.svg";
export { ForwardRef as ReactComponent };